import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MenuItem from '../../../common/menu/menu-item/menu-item';
import Menu from '../../../common/menu/menu';

export default class WidgetOptions extends Component {
  render() {
    return (
      <div className="glu-flex-shrink">
        <Menu>
          <MenuItem icon="info" onClick={this.props.showWidgetInfo}>
            View info
          </MenuItem>
          {this.props.openConfiguration && (
            <MenuItem icon="config" onClick={this.props.openConfiguration}>
              Configure
            </MenuItem>
          )}
          <MenuItem icon="clone" onClick={this.props.onClone}>
            Clone
          </MenuItem>
          <MenuItem icon="delete" onClick={this.props.onRemove}>
            Delete
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

WidgetOptions.propTypes = {
  onRemove: PropTypes.func.isRequired,
  showWidgetInfo: PropTypes.func.isRequired,
  openConfiguration: PropTypes.func,
  onClone: PropTypes.func.isRequired,
};

WidgetOptions.defaultProps = {
  openConfiguration: null,
};
